/**
 * 获取音频信息
 */
export function getAudioMeta(file: File): Promise<{
    duration: number;
}> {
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const audio = document.createElement('audio');

        audio.src = url;
        audio.preload = 'metadata';

        audio.onerror = reject;

        audio.onloadedmetadata = () => {
            resolve({
                duration: Math.floor(audio.duration * 1000),
            });

            URL.revokeObjectURL(url);
        };
    });
}

/**
 * 获取图片信息
 */
export function getImageMeta(file: File): Promise<{
    height: number;
    width: number;
}> {
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();

        img.src = url;

        img.onerror = reject;

        img.onload = () => {
            resolve({
                height: img.naturalHeight,
                width: img.naturalWidth,
            });

            URL.revokeObjectURL(url);
        };
    });
}

/**
 * 获取视频封面
 */
export function getVideoCover(file: File): Promise<Blob> {
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const video = document.createElement('video');

        video.src = url;
        video.muted = true;
        video.playsInline = true;

        video.onerror = reject;

        video.onloadedmetadata = () => {
            video.currentTime = Math.max(0.5, video.duration * 0.2);
        };

        video.onseeked = () => {
            const canvas = document.createElement('canvas');

            // 限制尺寸（避免超大图）
            const maxWidth = 400;
            const scale = maxWidth / video.videoWidth;

            canvas.width = maxWidth;
            canvas.height = video.videoHeight * scale;

            const ctx = canvas.getContext('2d');
            if (!ctx) return reject('canvas error');

            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            canvas.toBlob(
                (blob) => {
                    if (!blob) return reject('blob error');

                    resolve(blob);

                    URL.revokeObjectURL(url);
                },
                'image/jpeg',
                0.8,
            );
        };
    });
}

/**
 * 获取视频信息
 */
export function getVideoMeta(file: File): Promise<{
    duration: number;
    height: number;
    width: number;
}> {
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const video = document.createElement('video');

        video.src = url;
        video.muted = true;
        video.playsInline = true;
        video.preload = 'metadata';

        video.onerror = reject;

        video.onloadedmetadata = () => {
            resolve({
                duration: Math.floor(video.duration * 1000),
                height: video.videoHeight,
                width: video.videoWidth,
            });

            URL.revokeObjectURL(url);
        };
    });
}
